// extracted by css-extract-rspack-plugin
export default {"root":"SupportChatButton_root__Eh1hE","fixed":"SupportChatButton_fixed__24QcD"};